import { Directive, ElementRef, OnInit, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[takeFocus]',
  standalone: false,
})
export class TakeFocusDirective implements OnInit {
  private el = inject(ElementRef);

  constructor() {
    const el = this.el;

    if (!el.nativeElement.focus) {
      throw new Error('Element does not accept focus.');
    }
  }

  ngOnInit(): void {
    const input: HTMLElement = this.el.nativeElement as HTMLElement;
    input.focus();
  }
}
